import { LocalStorageCache } from '@auth0/auth0-react';

// A non-rotating refresh grant returns no refresh_token, and the SDK would overwrite the cached one.
export class RefreshTokenKeepingCache extends LocalStorageCache {
  set<T>(key: string, entry: T): void {
    const body = (entry as { body?: { access_token?: string; refresh_token?: string } }).body;
    if (body?.access_token && !body.refresh_token) {
      const previous = this.get(key) as { body?: { refresh_token?: string } } | undefined;
      if (previous?.body?.refresh_token) body.refresh_token = previous.body.refresh_token;
    }
    super.set(key, entry);
  }
}
